import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { preapreTimeAgo } from '../calloutRequested/calloutRequestedHelpers';
import { IRequestCalloutDTO } from '../calloutRequested/types/IRequestCalloutDTOs';
import CalloutStatuses from '../types/CalloutStatuses';


interface RequestedAgoLabelProps {
    row: IRequestCalloutDTO,
    isMyVehicle: boolean,
};

const useStyles = makeStyles(() => ({
    standard:{
        padding: '0px 0px 0px 3px',
        width: 110,

        "@media (max-width: 1280px)": {
            width: "unset"
          },
    },
    delayed:{
        padding: '0px 0px 0px 3px',
        width: 110,
        backgroundColor: '#F15454',
        borderRadius: 4
    }
}));

const delayTime = 5*60*1000;

const RequestedAgoLabel: React.FC<RequestedAgoLabelProps> = ({ row, isMyVehicle }) => {
    const classes = useStyles();
    const timer = React.useRef<any>(null);
    const [timeAgo, setTimeAgo] = React.useState('');
    const [delayed, setDelayed] = React.useState(false);

    React.useEffect(() => {
        setTimeAgo(preapreTimeAgo(row.createdOn));
        timer.current = setInterval(() => {
            const createdOn = row.createdOn ??'';
            if(isMyVehicle && row.status === CalloutStatuses.teamAcknowledged){
                const currentDate = new Date().getTime();
                const createdDate = createdOn?new Date(createdOn).getTime():currentDate;
                if(currentDate-createdDate > delayTime){
                    setDelayed(true);
                }else{
                    setDelayed(false);
                }
            }else{
                setDelayed(false);
            }
            setTimeAgo(preapreTimeAgo(createdOn));
        }, 1000);
        return () => {
            clearInterval(timer.current);
        };
    }, [row])


    return (
        <div className={delayed?classes.delayed:classes.standard}>
            {timeAgo} ago
        </div>
    );
}

export default RequestedAgoLabel;